export const RepoRouting = [
  {
    path: "/material/repo/list",
    name: "basic-material-repo-list",
    meta: { title: "仓库管理" },
    component: () =>
      import(/* webpackChunkName: "basic-material-repo" */ "@/views/material/repo/list/index.vue"),
  },
];
